import { Component, OnInit } from '@angular/core';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css']
})
export class EmailVerificationComponent implements OnInit {

  auth = new FirebaseTSAuth();
  currentUser: any = null; // Pour stocker les informations de l'utilisateur connecté

  



  constructor(private router: Router, private afAuth: AngularFireAuth, private firestore: AngularFirestore) { }

  ngOnInit(): void {
    /*if(
      this.auth.isSignedIn() &&
      !this.auth.getAuth().currentUser.emailVerified
      
    ) {
      alert("Bonjour, utilisateur authentifié");
      this.auth.sendVerificationEmail();
    } else {
      this.auth.listenToSignInStateChanges(
        user => {
          this.auth.checkSignInState(
            {
              
              whenSignedIn: user => {
  
                
              },
              whenSignedInAndEmailNotVerified: user => {
                this.auth.sendVerificationEmail();
              },
              whenSignedInAndEmailVerified: user => {
                this.router.navigate(["ProfileComponent"]);
                
              },
              whenChanged: user => {
                
              }
            }
          );
        }
      );
      /**this.router.navigate([""]); 
    } */


    // Vérifiez si un utilisateur est déjà connecté (valable uniquement pour l'authentification par numéro de téléphone)
    /*this.afAuth.authState.subscribe(user => {
      if (user) {
        this.currentUser = user;
        console.log('Utilisateur connecté :', user);
      }
    }); */


    // Écoutez l'état de connexion
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.currentUser = user;
        console.log('Utilisateur connecté :', user);
        
        // Vérifiez si l'utilisateur est connecté avec un email ou un numéro de téléphone
        if (user.email) {
          this.handleEmailVerification(user);
        } else if (user.phoneNumber) {
          this.handlePhoneVerification(user);
        }
      }
    });

   
  }

  /**
   * Gestion de l'authentification par email
   */
  private handleEmailVerification(user: any): void {
    if (user && !user.emailVerified && !user.email.endsWith("@lenali.ml")) {
      console.log("Bonjour, utilisateur connecté avec email non vérifié.");
      this.auth.sendVerificationEmail();
    } else if (user.emailVerified) {
      this.redirectToProfile();
    } else {
      this.auth.listenToSignInStateChanges(user => {
        this.auth.checkSignInState({
          whenSignedIn: user => {
              
            // Si l'utilisateur est connecté avec un numéro de téléphone
            const currentUser = this.auth.getAuth().currentUser;
           

            /* if (currentUser?.phoneNumber) {
              console.log("Utilisateur connecté avec un numéro de téléphone vérifié:", currentUser.phoneNumber);
              this.getUserProfile(); // Récupérer le profil utilisateur
            } */
            if (currentUser) {
              if (currentUser.isAnonymous) {
               /* console.log("Utilisateur connecté en tant qu'anonyme");
                this.router.navigate(["profileSetup"]); // Rediriger vers la configuration du profil */
              }  else if (currentUser.email.endsWith("@lenali.ml")) {
                
              }
            }
            
          },
          whenSignedInAndEmailNotVerified: user => {
            const currentUser = this.auth.getAuth().currentUser;
            if (currentUser) {
              if (currentUser.email.endsWith("@lenali.ml")) {
                
                console.log("Bonjour, utilisateur connecté avec email non vérifié. il y'a du travail");
              } else
              if (!currentUser.isAnonymous && !currentUser.emailVerified && !currentUser.email.endsWith("@lenali.ml")) {
                this.auth.sendVerificationEmail();
              } else if (currentUser.phoneNumber) {
                console.log("Utilisateur connecté avec un numéro de téléphone:", currentUser.phoneNumber);
                //this.getUserProfile();
              } else if (currentUser.emailVerified) {
                //this.getUserProfile();
              } 
            }
           
          },
         // whenSignedInAndEmailNotVerified: () => this.auth.sendVerificationEmail(),
          whenSignedInAndEmailVerified: () => this.redirectToProfile(),
          whenChanged: () => {}
        });
      });
    }
  }

   /**
   * Gestion de l'authentification par numéro de téléphone
   */
   private handlePhoneVerification(user: any): void {
    if (user && user.phoneNumber) {
      console.log('Utilisateur connecté avec numéro de téléphone vérifié :', user.phoneNumber);
      this.redirectToProfile(); // Considérez le numéro de téléphone comme automatiquement vérifié
    } else {
      console.error('Problème avec la vérification du numéro de téléphone.');
    }
  }

   /**
   * Redirige vers le profil utilisateur
   */
   private redirectToProfile(): void {
    this.router.navigate(["ProfileComponent"]);
  }

   /**
   * Méthode pour renvoyer un email de vérification
   */
   onResendClick(): void {
    if (this.currentUser?.email) {
      this.auth.sendVerificationEmail();
    } else {
      console.error("Impossible d'envoyer un email de vérification, utilisateur non connecté ou sans email.");
    }
  }

  /**
   * Recharge la page
   */
  reloadPage(): void {
    window.location.reload();
    console.log("Rechargement de la page...");
  }

  /*onResendClick(){
    this.auth.sendVerificationEmail();
  }

  reloadPage() {
    window.location.reload();
    console.log("rechargement");
  } */
}
